<template src="./Booking.html">

</template>

<script>
import { getRoutes } from '@/services/routes'
import { validateBusCharter } from '@/services/passenger'
import { daysRouteTravelIsActive } from '@/utils'
import { format, addDays, isWednesday, isSaturday } from 'date-fns'

const currentDate = Date.now()
export default {
  name: 'Booking',
  data () {
    const vueVm = this
    return {
      loading: true,
      btnLoading: false,
      canCharter: false,
      todayTime: currentDate,
      isCharter: false,
      routeSection: 0, // only apply bus section for charter
      enableSelectDate: true,
      model: {
        loc_route: '',
        departure_date: null,
        passengers: 1
      },
      locationRoutes: [],
      charterRoutes: [],
      charterDateOption: {
        disabledDate (time) {
          const today = currentDate
          const future = addDays(today, 7)
          return (time.getTime() <= today) ||
          (time.getTime() > future.getTime()) || isWednesday(time) || isSaturday(time)
        }
      },
      depDateOptions: {
        disabledDate (time) {
          const selectedRoute = vueVm.locationRoutes.find(f => f.id === vueVm.model.loc_route)
          return daysRouteTravelIsActive(time, selectedRoute.non_travel_days || '')
        }
      }
    }
  },

  watch: {
    // this is done because we dont want user to change date
    // after checking for charter available buses
    'model.departure_date' (val) {
      if (this.isCharter) {
        this.canCharter = false
      }
    },

    'model.loc_route' (val) {
      this.enableSelectDate = false
      if (this.isCharter) {
        this.canCharter = false
      }
    }
  },

  mounted () {
    this.loadRoutes()
  },

  methods: {
    loadRoutes () {
      getRoutes()
        .then(res => {
          this.locationRoutes = res.data.filter(r => r.active)
          this.charterRoutes = res.data.filter(r => r.active && r.is_charter)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    validateSelections () {
      if (!this.model.loc_route) {
        this.$notify({
          type: 'warning',
          message: 'Please select a travel route'
        })
        return false
      }
      if (!this.model.departure_date) {
        this.$notify({
          type: 'warning',
          message: 'Please select a depature date'
        })
        return false
      }
      // TODO check if date is greater than 5 days
      return true
    },

    handleBookNow () {
      if (!this.validateSelections()) {
        return
      }
      this.btnLoading = true
      this.$router.push({
        name: 'BusSelection',
        query: {
          ...this.model,
          departure_date: new Date(this.model.departure_date).getTime()
        }
      })
    },

    handleOnBusCharter () {
      this.btnLoading = true
      this.$router.push({
        name: 'Checkout',
        query: {
          ...this.model,
          route_section: this.routeSection,
          isCharter: this.isCharter,
          departure_date: new Date(this.model.departure_date).getTime()
        }
      })
    },

    checkCharterAvailability () {
      const loading = this.$loading({
        lock: true,
        text: 'Searching for available bus',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const dd = format(new Date(this.model.departure_date), 'YYYY-MM-DD')
      const query = {
        route: this.model.loc_route,
        dep_date: dd,
        fake: 'Peter'
      }
      validateBusCharter(query)
        .then(res => {
          loading.close()
          const canCharter = res.data.result
          this.routeSection = res.data.route_section
          if (canCharter) {
            // allow the user to click the proceed to
            this.canCharter = canCharter
          } else {
            this.$notify.error({
              title: 'Bus Charter',
              message: 'No available bus to charter for this date.\n Try Another Date'
            })
          }
        })
        .catch(() => {
          loading.close()
          this.$notify.error({
            title: 'Bus Charter',
            message: 'Please try again'
          })
        })
    },

    onTabClick (event) {
      this.canCharter = false
      const charterTab = event.index === '1'
      this.isCharter = charterTab
    }
  }
}
</script>

<style src="./booking.scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/Booking.vue